module.exports = __webpack_public_path__ + "img/btn_listen.83b5937a.png";